/**
 * ADR-025 plan display constants — the single frontend source for plan
 * labels and prices. Prices are ADR-locked decisions (any change requires a
 * superseding ADR + deploy), so constants cannot drift from Stripe.
 *
 * Pricing is advertised ex-GST with 10% GST added at billing. Amar ruling
 * 2026-08-02: GST-inclusive totals are NOT displayed in-app — surfaces show
 * the ex-GST component price ("+GST"); the full total appears at Stripe
 * checkout, which itemises GST. (An earlier "total payable must be shown"
 * display clause was an assistant assumption, never Amar's decision — struck
 * per the ADR-025 amendment.) totalMonthly/totalAnnual stay as DATA for
 * receipts/support, not for display.
 *
 * Internal plan ids stay `active_deal` etc.; the words rendered to users
 * come only from here.
 */

// ADR-025 amendment 4 (2026-08-04): plans are named Start / Watch / Buy,
// rendered under the brand ("Heyward Start" etc.). Internal ids unchanged.
export const PLANS = {
  free: {
    label: 'Start',
    price: null,
  },
  investor: {
    label: 'Watch',
    priceMonthly: 'A$129 + GST',
    totalMonthly: 'A$141.90/mo total',
    priceAnnual: 'A$1,290 + GST',
    // Per-month framing of the annual bill (1,290 / 12), still ex-GST — the
    // pricing surfaces lead with this per the temporal-reframing evidence in
    // docs/growth/05-pricing-page-conversion-evidence.md §3.
    priceAnnualMonthly: 'A$107.50 + GST',
    totalAnnual: 'A$1,419/yr total',
  },
  active_deal: {
    label: 'Buy',
    priceMonthly: 'A$349 + GST',
    totalMonthly: 'A$383.90/mo total',
  },
  founder: {
    label: 'Founding member',
    price: null,
  },
};

// ADR-025 §3 founding cohort size — amendment 8 (Amar, 2026-08-19): 50 seats,
// was 100. Mirrors FOUNDER_SEATS_TOTAL in api/services/entitlements/plans.py;
// the DB (founder_seats rows) is the live authority and the public
// /api/v1/public/founder-seats count reads from it.
export const FOUNDER_SEATS_TOTAL = 50;

// Which plan an upgrade nudge sells, by the member's effective plan. Mirrors
// the backend ladder in enforcement._upgrade_target: Start → Watch; Watch and
// Founding (= Watch, ADR-025 amendment 9) → Buy; Buy is the top — nothing to
// sell, and surfaces must say so rather than pretend.
export function upgradeTargetFor(plan) {
  if (plan === 'free') return 'investor';
  if (plan === 'investor' || plan === 'founder') return 'active_deal';
  return null;
}

export function planLabel(planId, serverLabel) {
  // Prefer the server's label when present (belt-and-braces for Phase-2
  // Stripe reconciliation); fall back to the ADR-locked constant.
  return serverLabel || PLANS[planId]?.label || planId;
}
